<label style='float:left; margin-top: 8px' floating>Al:</label>
    <input autocomplete="off" class="form-control " (click)="datePickerId.toggle()"  placeholder="gg-mm-aaaa" name="dp"
        [(ngModel)]="globalData.datePickerFinoA.dataSelezionataFinoA" ngbDatepicker #datePickerId="ngbDatepicker">